import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { BusinessPartnerDraft, BusinessPartnerEditableSite, BusinessPartnerRecord } from '../types/business-partner.types';

interface OnboardingValidationResponse {
  valid: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class BusinessPartnerManagementService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  private get baseUrl(): string {
    return `${window.location.protocol}//${window.location.hostname}${window.location.port !== '' ? ':8080' : ''}`;
  }

  private getRequestOptions(): { headers?: HttpHeaders } {
    const region = this.authService.getBusinessPartnerManagerRegion();

    if (!region) {
      return {};
    }

    return {
      headers: new HttpHeaders({
        'x-business-partner-region': region,
      }),
    };
  }

  getBusinessPartners(): Observable<BusinessPartnerRecord[]> {
    return this.http.get<BusinessPartnerRecord[]>(`${this.baseUrl}/data/businessPartners`, this.getRequestOptions());
  }

  getBusinessPartnerSites(): Observable<BusinessPartnerEditableSite[]> {
    return this.http.get<BusinessPartnerEditableSite[]>(`${this.baseUrl}/data/businessPartnerSites`, this.getRequestOptions());
  }

  validateBusinessPartnerOnboarding(payload: Pick<BusinessPartnerDraft, 'domainName' | 'manuallyAddedUsers'> & { previousDomainName?: string }): Observable<OnboardingValidationResponse> {
    return this.http.put<OnboardingValidationResponse>(`${this.baseUrl}/data/validateBusinessPartnerOnboarding`, payload, this.getRequestOptions());
  }

  upsertBusinessPartner(payload: BusinessPartnerDraft & { updatedBy?: string; updatedByMail?: string; previousDomainName?: string }): Observable<BusinessPartnerRecord> {
    return this.http.put<BusinessPartnerRecord>(`${this.baseUrl}/data/upsertBusinessPartner`, payload, this.getRequestOptions());
  }

  deleteBusinessPartner(domainName: string): Observable<{ deleted: boolean }> {
    return this.http.delete<{ deleted: boolean }>(`${this.baseUrl}/data/deleteBusinessPartner/${encodeURIComponent(domainName)}`, this.getRequestOptions());
  }
}
